import SummaryMetrics from "../../../../components/Reports/SummaryMetrics";
import { PnlBreakdown } from "../../../../getters/pnlBreakdownGetter/pnlBreakdownTypes";
import { useSummaryMetrics } from "reports/utils/metricUtils";
import { MetricEnum } from "reports/utils/metricTypes";
import { defaultMetricGrey } from "reports/constants/colors";
import { useReportConfig } from "components/DataGetter/FlightConfig/useFlightConfig";

const DEFAULT_SUMMARY_METRICS1 = [
  { name: MetricEnum.OEE, color: defaultMetricGrey },
  { name: MetricEnum.AVAIL, color: defaultMetricGrey },
  { name: MetricEnum.QUALITY, color: defaultMetricGrey },
  { name: MetricEnum.PERF, color: defaultMetricGrey },
  { name: MetricEnum.TAGGING, color: defaultMetricGrey },
];

const DEFAULT_SUMMARY_METRICS2 = [
  { name: MetricEnum.COUNT, title: "Accepted Parts" },
  { name: MetricEnum.REJECT_COUNT, title: "Rejected Parts" },
];

export default function MeritmedicaltijuanaSummaryMetrics({
  data,
  processGroupName,
}: {
  data: PnlBreakdown;
  processGroupName?: string;
}) {
  const reportConfig = useReportConfig();

  const summaryMetricsRow1 = useSummaryMetrics({
    metrics:
      reportConfig?.eosReportMetricsConfig?.summaryMetricsRow1 ??
      DEFAULT_SUMMARY_METRICS1,
    pnlBreakdown: data,
  });

  const summaryMetricsRow2 = useSummaryMetrics({
    metrics:
      reportConfig?.eosReportMetricsConfig?.summaryMetricsRow2 ??
      DEFAULT_SUMMARY_METRICS2,
    pnlBreakdown: data,
  });

  return (
    <SummaryMetrics
      processGroupName={processGroupName}
      summaryMetrics={[summaryMetricsRow1, summaryMetricsRow2]}
    />
  );
}
